import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ReferenceLine } from "recharts";
import { InfoHint } from "./InfoHint";
import { ArrowsCounterClockwise } from "@phosphor-icons/react";

export default function RecoveryAfterLoadCard({ rows }) {
  if (!rows || rows.length < 2) return null;
  const heavy = rows.find((r) => r.label.startsWith("Тяжёлые"));
  let note = null;
  if (heavy) {
    const days = [heavy.rec_d1, heavy.rec_d2, heavy.rec_d3];
    const greenIdx = days.findIndex((v) => v != null && v >= 67);
    note = greenIdx >= 0
      ? <>После тяжёлых дней вы в среднем возвращаетесь в зелёную зону на <span className="text-[#00e676] font-semibold">{greenIdx + 1}-й день</span>.</>
      : <>После тяжёлых дней ваше восстановление в среднем не достигает зелёной зоны даже к 3-му дню — планируйте больше отдыха.</>;
  }
  return (
    <div className="glass-card p-5" data-testid="recovery-after-load">
      <div className="flex items-center gap-2 mb-1">
        <ArrowsCounterClockwise size={18} weight="fill" className="text-[#0084ff]" />
        <h3 className="text-sm font-semibold">Сколько дней нужно на восстановление<InfoHint text="Среднее время возврата в зелёную зону восстановления после лёгкой, средней и тяжёлой нагрузки — по вашей личной истории." /></h3>
      </div>
      <p className="text-xs text-muted-foreground mb-4">
        Среднее восстановление через 1, 2 и 3 дня после дней разной нагрузки. {note}
      </p>
      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={rows}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(220 10% 16%)" vertical={false} />
          <XAxis dataKey="label" stroke="hsl(220 10% 40%)" fontSize={11} tickLine={false} axisLine={false} />
          <YAxis domain={[0, 100]} stroke="hsl(220 10% 40%)" fontSize={11} tickLine={false} axisLine={false} width={30} />
          <Tooltip contentStyle={{ background: "hsl(220 10% 12%)", border: "1px solid hsl(220 10% 22%)", borderRadius: 8, fontSize: 12 }} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <ReferenceLine y={67} stroke="#00e676" strokeDasharray="4 4" strokeOpacity={0.4} />
          <Bar dataKey="rec_d1" name="Через 1 день" fill="#0084ff" radius={[3, 3, 0, 0]} />
          <Bar dataKey="rec_d2" name="Через 2 дня" fill="#a970ff" radius={[3, 3, 0, 0]} />
          <Bar dataKey="rec_d3" name="Через 3 дня" fill="#00e676" radius={[3, 3, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
